import React from "react";
import { Box, Typography, Chip } from "@mui/material";

// Simplified RoomsCard for public selection of classes/rooms.
const PublicRoomsCard = ({ title, allRooms, selectedRooms, onSelectionChange }) => {
  
  const handleToggle = (room) => {
    const isSelected = selectedRooms.some((r) => r.id === room.id);
    const newSelection = isSelected
      ? selectedRooms.filter((r) => r.id !== room.id)
      : [...selectedRooms, room];
    onSelectionChange(newSelection);
  };

  return (
    <Box className="info-card mb-4 shadow-sm">
      <div className="info-card-header" style={{ padding: "15px" }}>
        <Typography variant="h6">{title}</Typography>
      </div>
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {allRooms.map((room) => {
            const isSelected = selectedRooms.some((r) => r.id === room.id);
            return (
              <Chip
                key={room.id}
                label={room.ClassName || room.room} 
                onClick={() => handleToggle(room)}
                color={isSelected ? "primary" : "default"}
                variant={isSelected ? "filled" : "outlined"}
                sx={{ cursor: "pointer", transition: "0.3s" }}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default PublicRoomsCard;